<template>
  <div>
    <card-wrapper :title="$t('honda.registration.list.title')" id="registrations-list">
      <registrations-table :filter-list="filters" :default-filters="defaultFilters" />
    </card-wrapper>
  </div>
</template>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import CardWrapper from '@/components/general/CardWrapper.vue'
import RegistrationsTable from '@/components/registrations/HondaRegistration/RegistrationsTable.vue'
import {RegistrationArchivedFilters, RegistrationFilters} from '@/types'
import {mapGetters} from '@/utils/map-store'

export default defineComponent({
  name: 'Registrations',
  components: {
    RegistrationsTable,
    CardWrapper,
  },
  setup(props, {root}) {
    const {getPermissions: permissions} = mapGetters(root.$store.getters)

    const filters = [...Object.values(RegistrationFilters), RegistrationArchivedFilters.ArchivedPending]
    const defaultFilters = [
      RegistrationFilters.PendingSign,
      RegistrationFilters.PendingRegister,
      RegistrationFilters.PendingCommunication,
    ] as RegistrationFilters[]

    if (permissions.value.registrationArchivedFilters.canSee) {
      filters.push(RegistrationArchivedFilters.ArchivedTotal)
    }

    return {
      filters,
      defaultFilters,
    }
  },
})
</script>
